import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next'
import { Const } from 'constants/index'
import { ENV } from 'utils/env';

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    lng: Const.defaultLng,
    whitelist: Const.locates,
    backend: {
      /* translation file path */
      loadPath: '/language/{{ns}}/{{lng}}.json'
    },
    fallbackLng: 'fr',
    debug: ENV.NODE_ENV !== "production",
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      useSuspense: true
    }
  })

export default i18n
